import { gql } from "@apollo/client";

const getUpcomingMeetingsQuery = gql`
  fragment UpcomingMeeting on MeetingNode {
    id
    title
    startDatetime
    endDatetime
    meetingGroupId
    draft
    isLocked
    isFinalized
  }
  query getUpcomingMeetings(
    $startDatetimeAfter: DateTime
    $participants: [Int!]
    $isFormalOneonone: Boolean
    $orderBy: String = "start_datetime"
  ) {
    meetings(
      isFormalOneonone: $isFormalOneonone
      startDatetime_Gte: $startDatetimeAfter
      participants: $participants
      orderBy: $orderBy
      first: 20
    ) {
      edges {
        node {
          ...UpcomingMeeting
        }
      }
    }
  }
`;

export default getUpcomingMeetingsQuery;
